import { getCookiesAsObject } from '@whitelabel/helpers/utils';
import { AUTH_TOKEN_STORAGE_NAME } from '@whitelabel/rentalcover-shared/helpers/constants';

export const getRCAuthToken = (): string | undefined => getCookiesAsObject()?.[AUTH_TOKEN_STORAGE_NAME];

const REFRESH_TOKEN_KEY = 'RC_REFRESH_TOKEN';

export const getRefreshToken = (): string | null => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setRefreshToken = (token: string): void => localStorage.setItem(REFRESH_TOKEN_KEY, token);
export const clearRefreshToken = (): void => localStorage.removeItem(REFRESH_TOKEN_KEY);
